import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ src, ...props }) =>
  src ? <img src={src} {...props} role="presentation" /> : null;

Image.propTypes = {
  src: PropTypes.string.isRequired,
};

export default Image;
